import React from 'react'
import { useState } from 'react'
import { useRef } from 'react'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Seen from '../../component/Page/Seen'

const Team = () => {
    const team = [
        {
            img: "./../images/av (7).png",
            name: "Nolan Korsgaard",
            title: "Founder & Owners"
        },
        {
            img: "./../images/av (8).png",
            name: "Jaylon Vaccaro",
            title: "Founder & Owners"
        },
        {
            img: "./../images/av (1).png",
            name: "Ryan Gouse",
            title: "Founder & Owners"
        },
        {
            img: "./../images/av (6).png",
            name: "Cooper Saris",
            title: "Founder & Owners"
        },

        {
            img: "./../images/avr (1).png",
            name: "Jocelyn Aminoff",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (2).png",
            name: "Gretchen Stanton",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (3).png",
            name: "Carla Vaccaro",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (4).png",
            name: "Corey Franci",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (5).png",
            name: "Talan Rosser",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (6).png",
            name: "Phillip  Bothman",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (7).png",
            name: "Alfonso Donin",
            title: "Founder & Owners"
        },
        {
            img: "./../images/avr (8).png",
            name: "Lydia Arcand",
            title: "Founder & Owners"
        },
    ]


    const upload = useRef(null);
    const [file, setFile] = useState(null)
    const onClickUpload = (e) => {
        upload.current.click()
    }
    const onChangeHandle = (e) => {
        setFile(e.target.files[0].name)
    }
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section className="position-relative">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="medium font__size--56 text__50-1024 text__50-sm text__50-xs play">Meet Our Team</h2>
                        <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024  text-capitalize color__brown">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">our team</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                    </div>


                    <div className="row">
                        {
                            team.map((obj) => {
                                return <div className="col-6 wrapper__pd-wrap col-md-4 col-lg-3 mb-4">
                                    <div className="wrapper__card-team text-center">
                                        <img src={obj.img} className='profile' alt="" />

                                        <div className="my-3">
                                            <h4 className='medium font__size--20 text__20-1024 play'>{obj.name}</h4>
                                            <p className='normal font__size--14 text__14-1024 color__gray-1'>{obj.title}</p>
                                        </div>

                                        <div className="sosmed">
                                            <a href="#!">
                                                <img src="./../images/soss (3).png" alt="" />
                                            </a>
                                            <a href="#!">
                                                <img src="./../images/soss (1).png" alt="" />
                                            </a>
                                            <a href="#!">
                                                <img src="./../images/soss (2).png" alt="" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>

                </div>
            </section>

            <section>
                <div className="container">

                    <div className="wrapper__form-position">
                        <div className="mb-5 text-center">
                            <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text__24-1024  text-capitalize color__brown mb-3">
                                <img src="./../images/Vector 2.png" alt="" />
                                <span className="mx-3">Available position</span>
                                <img src="./../images/Vector 1.png" alt="" />
                            </div>
                            <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play color__white">Join Our Team to Help Couples Plan <br className='d-none d-md-block' /> Their Dream Wedding!</h2>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input color__white white' placeholder='First Name' />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input color__white white' placeholder='Last Name' />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input color__white white' placeholder='Email' />
                        </div>

                        <div className="form-group">
                            <select name="" id="" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input color__white white' placeholder='Position'>
                                <option value="" disabled selected hidden>Position</option>
                                <option value="">Fotografer</option>
                            </select>
                        </div>

                        <div className="wrapper__upload-cv position-relative d-flex align-items-center justify-content-between color__white">
                            <p className='mb-0 play font__size--14 text__14-1024 normal pointer w-100' onClick={onClickUpload}>{file ? file : "Attach portfolio or CV"}</p>
                            <input ref={upload} onChange={onChangeHandle} type="file" />
                            <img src="./../images/Clip, Attachment.png" onClick={onClickUpload} className='pointer' alt="" />
                        </div>

                        <button className='medium font__size--16 btn btn__darkgreen color__white shadow rounded__50 mt-4'>Submit</button>
                    </div>
                </div>
            </section>

            <Seen />

            <Contact />

            <Footer />
        </div >
    )
}

export default Team